import axios from 'axios';

const instance = axios.create();

instance.interceptors.request.use(
  (config) => {
    // 공용 headers 설정 방식
    config.headers = { 
      'env': `${process.env.VUE_APP_HEADER_ENV}`
    }
    const jwt = window.localStorage.getItem('jwt');

    if (jwt) {
      Object.assign(config.headers, { 'jwt': jwt });
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  });

export default instance;